export const menuItemsList = [
        {
            title: 'home',
            url: '/',

        },
        {
            title: 'info ⌵ ',
            url: '/faq',
            submenu: [
                {
                    title: 'Disks',
                    url: '/faq/#algemeen',
                },
                {
                    title: 'Gebruik',
                    url: '/faq/#gebruik',
                },
                {
                    title: 'Kiezen',
                    url: '/faq/#kiezen',
                },
                {
                    title: 'Problemen',
                    url: '/faq/#problemen',
                },
            ],
        },
        {
            title: 'diskquiz',
            url: '/diskquiz',
        },

        {
            title: 'contact',
            url: '/contact',
        },
    ]
;